"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }









var _array = require('shared/services/array');

 const EMPTY_SUBSCRIBERS_LIST = {
  userSubscribersList: [],
  teamSubscribersList: [],
  patientSubscribersList: [],
}; exports.EMPTY_SUBSCRIBERS_LIST = EMPTY_SUBSCRIBERS_LIST

const compareSubscriberKeys = (
  subscribers,
) => {
  return (a, b) => {
    const subA = subscribers[a ] 
    const subB = subscribers[b ] 
    const timeA = _optionalChain([subA, 'optionalAccess', _ => _.UpdatedAt]) || ''
    const timeB = _optionalChain([subB, 'optionalAccess', _2 => _2.UpdatedAt]) || ''

    if (timeA !== timeB) return timeA.localeCompare(timeB)
    return a.localeCompare(b)
  }
}

 const populateSubscribers = 





 (
    subscribers,
    allEntitiesMap,
  ) =>
    Object.keys(subscribers)
      .sort(compareSubscriberKeys(subscribers))
      .map(k => allEntitiesMap[k ])
      .filter(_array.truthy); exports.populateSubscribers = populateSubscribers

 const unsafePopulateSubscribers = 









 (
    subscribers,
    allEntitiesMap,
    makeBaseSubscriber,
  ) =>
    Object.keys(subscribers)
      .sort(compareSubscriberKeys(subscribers))
      .map(k => {
        const key = k 
        return allEntitiesMap[key] || makeBaseSubscriber(key)
      })
      .filter(_array.truthy); exports.unsafePopulateSubscribers = unsafePopulateSubscribers
